import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-bulk',
  templateUrl: './payments-bulk.component.html',
  styleUrls: ['./payments-bulk.component.css']
})
export class PaymentsBulkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
